import {
  CheckCircleIcon,
  AlertTriangleIcon,
  InfoIcon,
  XCircleIcon,
  CloseIcon,
} from "../../../assets/svgIcons";

/**
 * Get the appropriate icon component based on message type
 * @param {string} type - The message type ('success', 'warning', 'error', 'info')
 * @returns {React.Component} Icon component
 */
export const getIcon = (type) => {
  switch (type) {
    case "success":
      return CheckCircleIcon;
    case "warning":
      return AlertTriangleIcon;
    case "error":
      return XCircleIcon;
    case "info":
    default:
      return InfoIcon;
  }
};

/**
 * Export CloseIcon component for use in Message component
 */
export { CloseIcon };
